import * as React from "react"

import { cn } from "@/lib/utils"

const ScrollArea = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("relative h-full min-h-0 overflow-auto custom-scrollbar", className)}
    {...props}>
    {children}
  </div>
))
ScrollArea.displayName = "ScrollArea"

export { ScrollArea }
